import React from 'react';

const Contact: React.FC = () => {
  return (
    <div>
      {/* Get Touch Section */}
      <section className="get_touch_section" id="Our_get_touch_sec">
        <div className="get_touch_inner_prea" id="common_banner_sec">
          <div className="page_navegation_area">
            <div className="container">
              <div className="page_navegation font_two">
                <p><a href="/">Home</a> / <span className="active fw_700">Contact Us</span></p>
              </div>
            </div>
          </div>
          <div className="get_touch_sec">
            <div className="container">
              <div className="get_touch_area">
                <div className="row align-items-center">
                  <div className="col-xl-6">
                    <div className="get_touch_content">
                      <div className="responsive-map position-relative overflow-hidden">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.786728502161!2d72.77028821541435!3d21.160884085927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04d91b765a3a3%3A0x632d46b1abea0c5e!2sKG%20FITNESS%20SURAT!5e0!3m2!1sen!2sin!4v1643439525386!5m2!1sen!2sin"
                          allowFullScreen
                          title="Location Map"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="get_touch_content">
                      <div className="get_touch_form bg_white">
                        <form action="" className="row">
                          <div className="col-12">
                            <div className="get_touch_form_title_area">
                              <h2 className="heading_text_2">Send us an Email</h2>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="get_touch_form_info font_two">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="get_touch_form_box">
                                    <label htmlFor="u_name">Name</label>
                                    <input type="text" id="u_name" placeholder="Enter your Name" className="get_touch_form_field" required />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="get_touch_form_box">
                                    <label htmlFor="u_mail">Email</label>
                                    <input type="email" id="u_mail" placeholder="Enter your Email" className="get_touch_form_field" required />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="get_touch_form_box">
                                    <label htmlFor="u_msg">Message</label>
                                    <textarea id="u_msg" placeholder="Write your Message" className="get_touch_form_field" required></textarea>
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="get_touch_btn_area text-end" style={{ display: 'flex', justifyContent: 'end' }}>
                                    <div>
                                      <button type="submit" className="blue_btn" onClick={(e) => { }}>
                                        Send
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      {/* <section className="contact_section">
        <div className="contact_sec">
          <div className="container">
            <div className="contact_area color_lightwhite">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="contact_area_info d-flex flex-column">
                    <div className="contact_info_title_area d-flex flex-column text-lg-start text-center justify-content-lg-start justify-content-center">
                      <h2 className="heading_text_2">Get the latest Digi Cart updates</h2>
                      <p className="font_two">Subscribe for product releases, marketplace tips, and exclusive offers—straight to the inbox.</p>
                    </div>
                    <form action="#" className="contact_area_form">
                      <div className="contact_area_form_box position-relative">
                        <input type="email" placeholder="Enter your email" required />
                        <button type="submit" className="blue_btn">Submit Email</button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-6 d-lg-flex d-none">
                  <div className="contact_img_area_info">
                    <div className="contact_img_area">
                      <img src="/assets/images/contact_sec_img_1.png" alt="contact_sec_img" />
                      <img src="/assets/images/contact_sec_img_2.png" alt="contact_sec_img" />
                    </div>
                    <div className="contact_img_area">
                      <img src="/assets/images/contact_sec_img_3.png" alt="contact_sec_img" />
                      <img src="/assets/images/contact_sec_img_4.png" alt="contact_sec_img" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Contact;
